<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <section class="w-full max-w-hero-block mx-auto flex flex-col items-center text-center px-lg">
    <h1 class="text-headline-large font-bold text-text-primary">{{ t('heroTitle') }}</h1>
    <p class="mt-sm text-title-medium font-regular text-text-secondary">{{ t('heroSubtitle') }}</p>
    <div class="mt-3xl w-full grid grid-cols-1 md:grid-cols-3 gap-xl">
      <div class="flex flex-col items-center gap-sm">
        <div class="w-14 h-14 rounded-pill bg-brand-100 flex items-center justify-center text-brand-700">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
            <polyline points="16 7 22 7 22 13" />
          </svg>
        </div>
        <h3 class="text-title-medium font-semibold">{{ t('infoGrid1Title') }}</h3>
        <p class="text-body-small text-text-secondary max-w-xs">{{ t('infoGrid1Desc') }}</p>
      </div>
      <div class="flex flex-col items-center gap-sm">
        <div class="w-14 h-14 rounded-pill bg-brand-100 flex items-center justify-center text-brand-700">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="20" x2="12" y2="10" />
            <line x1="18" y1="20" x2="18" y2="4" />
            <line x1="6" y1="20" x2="6" y2="14" />
          </svg>
        </div>
        <h3 class="text-title-medium font-semibold">{{ t('infoGrid2Title') }}</h3>
        <p class="text-body-small text-text-secondary max-w-xs">{{ t('infoGrid2Desc') }}</p>
      </div>
      <div class="flex flex-col items-center gap-sm">
        <div class="w-14 h-14 rounded-pill bg-brand-100 flex items-center justify-center text-brand-700">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 17 9 11 13 15 21 7" />
            <polyline points="14 7 21 7 21 14" />
          </svg>
        </div>
        <h3 class="text-title-medium font-semibold">{{ t('infoGrid3Title') }}</h3>
        <p class="text-body-small text-text-secondary max-w-xs">{{ t('infoGrid3Desc') }}</p>
      </div>
    </div>
  </section>
</template>
